import axios from 'axios'

import { API_ENDPOINTS } from '@/constants'

class CalculationsQueries {
    fetchCalculations(queryString = '') {
        const url = `/calculations/calculations${queryString ? `?${queryString}` : ''}`
        return axios.get(url)
    }

    createCalculation(payload) {
        return axios.post('/calculations/calculations', payload, {
            timeout: 0
        })
    }

    fetchCalculation(calculationId) {
        return axios.get(`/calculations/calculations/${calculationId}`)
    }

    fetchCalculationProductTypes() {
        return axios.get('/calculations/calculation-product-types')
    }

    fetchCalculationProductType(productTypeId) {
        return axios.get(`/calculations/calculation-product-types/${productTypeId}`)
    }

    updateCalculation(calculation) {
        return axios.put(`/calculations/calculations/${calculation.id}`, calculation, {
            timeout: 0
        })
    }

    updateCalculationTraderMargin(payload) {
        return axios.patch(`/calculations/calculation-trader-margin/${payload.id}`, payload)
    }

    deleteCalculation(calculationId) {
        return axios.delete(`/calculations/calculations/${calculationId}`)
    }

    copyCalculation(payload) {
        return axios.post('/calculations/copy-calculation', payload)
    }

    copyCalculationImpositionParameters(payload) {
        return axios.post('/calculations/copy-calculation-imposition-parameters', payload)
    }

    fetchCalculationValidation(calculationId) {
        return axios.get(`/calculations/calculations/${calculationId}/validation`)
    }

    fetchCalculationDieCutters() {
        return axios.get('/calculations/calculations/die-cutters')
    }

    fetchCalculationImpositionTask(taskId) {
        return axios.get(`/calculations/calculations/imposition-task/${taskId}`)
    }

    updateCalculationImpositionTask(task) {
        return axios.put(`/calculations/calculations/imposition-task/${task.id}`, task, {
            timeout: 0
        })
    }

    fetchCalculationImpositionTaskPriceComponents(calculationPk) {
        return axios.get(`/calculations/calculation/${calculationPk}/calculation-imposition-task-price-components`)
    }

    updateCalculationImpositionTaskPriceComponents({ calculationPk, id, ...payload }) {
        return axios.put(
            `/calculations/calculation/${calculationPk}/calculation-imposition-task-price-components/${id}`,
            payload,
            {
                timeout: 0
            }
        )
    }

    fetchCalculationImposition(impositionId) {
        return axios.get(`/calculations/calculations/imposition/${impositionId}`)
    }

    updateCalculationImposition(imposition) {
        return axios.put(`/calculations/calculations/imposition/${imposition.id}`, imposition, {
            timeout: 0
        })
    }

    updateCalculationImpositionPaperConfiguration({ impositionId, ...payload }) {
        return axios.put(API_ENDPOINTS.CALCULATIONS.IMPOSITION_PAPER_CONFIGURATION(impositionId), payload, {
            timeout: 0
        })
    }

    fetchCalculationPrintColours(machineId) {
        return axios.get('/calculations/dicts/calculation-print-colour', { params: { machine_id: machineId } })
    }

    fetchCalculationColourTemplates() {
        return axios.get('/calculations/dicts/calculation-colour-template')
    }

    fetchCalculationStatuses() {
        return axios.get('/calculations/dicts/calculation-status')
    }

    printCalculationPriceOffer(payload) {
        return axios.post('/calculations/calculations/card-print', payload, {
            responseType: 'arraybuffer'
        })
    }

    printCalculationReport(payload) {
        return axios.post('/calculations/calculations/card-print', payload, {
            responseType: 'arraybuffer'
        })
    }
}

export default new CalculationsQueries()
